module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Schwaderloch-fb6fde5b68c2153579f4e7d1da3157c7.svg";